var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 25,
    cy: 25,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.32,27.4926686 L22.6,19.340176 L22.42,15 L27.58,15 L27.4,19.340176 L26.68,27.4926686 L23.32,27.4926686 Z M25,35 C23.26,35 22,33.6510264 22,31.9501466 C22,30.2492669 23.26,28.9002933 25,28.9002933 C26.74,28.9002933 28,30.2492669 28,31.9501466 C28,33.6510264 26.74,35 25,35 Z",
    id: "!",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconBase);
export default __webpack_public_path__ + "static/media/warning-icon-base.55f0a84a51a16f8acee97aebcf85d416.svg";
export { ForwardRef as ReactComponent };